import React , {useState} from "react";
import axios from "axios";
import axiosClient from "../services/axiosClient";
import { Modal, Button, Form, Row, Col , Alert } from "react-bootstrap";
import './reportGeneration.css'
import Loader from "../../utils/Loader";

const PDFDownloader = ({patientId}) => {
    const [showViewModel, setShowViewModel] = useState(false);
  const [ loading , setLoading] = useState(false);


const downloadPDF = async (data) => {
  try {
    const response = await axiosClient.get("/patient-service/report-generate-patient", {
      responseType: "blob",
      params: data,
      headers: {
        Accept: "application/pdf",
        "Content-Type": "application/pdf",
      },
    });

    // Extract filename from Content-Disposition header
    const contentDisposition = response.headers["content-disposition"];
    let filename = "report.pdf";
    if (contentDisposition) {
      const match = contentDisposition.match(/filename="?([^"]+)"?/);
      if (match?.[1]) {
        filename = match[1];
      }
    }

    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();

    // Cleanup
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading PDF:", error);
  }
};


  const [selectedSections, setSelectedSections] = useState({
    profile: true,
    treatment: false,
    adherence: false,
    notes: false,
    patientId:patientId,
    bladderJournal: false,
  });


  const [error, setError] = useState("");

  const handleCheckboxChange = (section) => {
    setSelectedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
    setError("");
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    if (!Object.values(selectedSections).includes(true)) {
      setError("Please select at least one section to export.");
      return;
    }

    setLoading(true);
    handleClose();
    // handleExport(selectedSections);
    await downloadPDF(selectedSections)

    setLoading(false);

  };

  const handleClose = () => setShowViewModel(false);

  return (
    <> 
    {
      loading && <Loader />
    }
        <div style={{ textAlign: "center", marginTop: "20px" }}>
      <Button className="btn filled-btn"
        onClick={()=>{setShowViewModel(true)}}
        // style={{
        //   padding: "10px 20px",
        //   fontSize: "16px",
        //   backgroundColor: "#007bff",
        //   color: "#fff",
        //   border: "none",
        //   borderRadius: "5px",
        //   cursor: "pointer",
        // }}
      >
        Generate Report
      </Button>
    </div>


    
    <Modal show={showViewModel} onHide={handleClose} centered className="report-modal">
      <Modal.Header closeButton className="header text-white">
        <Modal.Title>Export Patient Profile</Modal.Title>
      </Modal.Header>
      <Modal.Body>
      {error && <Alert variant="danger">{error}</Alert>}
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={6}>
              <Form.Group controlId="profile" className="mb-3 p-3 border rounded">
                <Form.Check
                  type="checkbox"
                  label="Patient Profile"
                  checked={selectedSections.profile}
                  onChange={() => handleCheckboxChange("profile")}
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group controlId="treatment" className="mb-3 p-3 border rounded">
                <Form.Check
                  type="checkbox"
                  label="Medication Section"
                  checked={selectedSections.treatment}
                  onChange={() => handleCheckboxChange("treatment")}
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group controlId="adherence" className="mb-3 p-3 border rounded">
                <Form.Check
                  type="checkbox"
                  label="Adherence Statistics"
                  checked={selectedSections.adherence}
                  onChange={() => handleCheckboxChange("adherence")}
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group controlId="notes" className="mb-3 p-3 border rounded">
                <Form.Check
                  type="checkbox"
                  label="Notes Section"
                  checked={selectedSections.notes}
                  onChange={() => handleCheckboxChange("notes")}
                />
              </Form.Group>
            </Col>

                        <Col md={6}>
              <Form.Group controlId="bladderJournal" className="mb-3 p-3 border rounded">
                <Form.Check
                  type="checkbox"
                  label="Bladder Journal Section"
                  checked={selectedSections.bladderJournal}
                  onChange={() => handleCheckboxChange("bladderJournal")}
                />
              </Form.Group>
            </Col>
          </Row>

          <div className="d-flex gap-3 justify-content-end mt-4">
            <Button variant="" onClick={handleClose} className="px-4 btn border-btn outlined-btn btn btn-primary">
              Cancel
            </Button>
            <Button variant="primary" type="submit" className="px-4 btn dark-btn filled-btn">
              Export
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>

      </>

  );
};

export default PDFDownloader;
